import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

// Same jobs list as Careers.js
const jobs = [
  { id: 1, title: "Front-End Developer", type: "Full-Time", icon: "💻" },
  { id: 2, title: "UI/UX Designer", type: "Part-Time", icon: "🎨" },
  { id: 3, title: "Backend Developer", type: "Remote", icon: "🖥️" },
  { id: 4, title: "Mobile App Developer", type: "Full-Time", icon: "📱" },
  { id: 5, title: "SEO Specialist", type: "Remote", icon: "🚀" },
];

const CareerApply = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", resume: null });

  // Find the job by ID
  const job = jobs.find((j) => j.id === parseInt(jobId));

  const handleSubmit = (e) => {
    e.preventDefault();
    alert(`Applied for Job: ${job?.title}\nName: ${form.name}`);
    navigate("/careers"); // redirect back
  };

  return (
    <div className="max-w-md mx-auto mt-20 p-6 border rounded shadow">
      <h2 className="text-2xl font-bold mb-4">
        Apply for: {job ? job.title : "Unknown Job"}
      </h2>

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          type="text"
          placeholder="Full Name"
          value={form.name}
          onChange={(e) => setForm({ ...form, name: e.target.value })}
          className="border p-2 rounded"
          required
        />
        <input
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          className="border p-2 rounded"
          required
        />
        <input
          type="file"
          onChange={(e) => setForm({ ...form, resume: e.target.files[0] })}
          className="border p-2 rounded"
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Submit Application
        </button>
      </form>
    </div>
  );
};

export default CareerApply;
